import React from 'react';

import {CheckIcon} from '../../svg-icon';
import {cls} from '../../../utils';

import css from './checkmark.module.css';

type Props = {
	checked?: boolean;
	/** выбрана часть: вместо галочки черта */
	indeterminate?: boolean;
	disabled?: boolean;
	/** без обработчика квадрат только рисуется: так его показывает Checkbox рядом с подписью */
	onChange?: (checked: boolean) => void;
	className?: string;
	/** подсказка при наведении, например почему квадрат недоступен */
	title?: string;
	'aria-label'?: string;
};

export const Checkmark: React.FC<Props> = ({
	checked,
	indeterminate,
	disabled,
	onChange,
	className,
	title,
	...rest
}) => {
	const interactive = Boolean(onChange);
	const toggle = (event: React.SyntheticEvent) => {
		event.stopPropagation();
		if (!disabled) onChange?.(!checked);
	};

	return (
		<span
			className={cls(
				css.checkmark,
				interactive && css.interactive,
				(checked || indeterminate) && css.checked,
				disabled && css.disabled,
				className,
			)}
			title={title}
			{...(interactive
				? {
						role: 'checkbox',
						'aria-checked': indeterminate ? 'mixed' : checked ? 'true' : 'false',
						'aria-disabled': disabled || undefined,
						'aria-label': rest['aria-label'],
						tabIndex: disabled ? -1 : 0,
						onClick: toggle,
						onKeyDown: (event: React.KeyboardEvent) => {
							if (event.key !== ' ' && event.key !== 'Enter') return;
							event.preventDefault();
							toggle(event);
						},
					}
				: {'aria-hidden': true})}
		>
			{indeterminate ? <span className={css.indeterminateMark} /> : <CheckIcon width={15} height={15} />}
		</span>
	);
};
